import React, { useState } from 'react';
import { Link } from 'react-router-dom';
const logo = '/images/greenorange-logo.jpg';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleNav = () => {
    setIsOpen(!isOpen);
  };

  const handleDropdownToggle = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  return (
    <header id="gotop">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
            <Link to="/" title="Green Orange Information Technology">
              <img src={logo} alt="greenorange-logo" className="logo" />
            </Link>
          </div>
          <div className="col-lg-7 col-md-7 col-sm-8 col-xs-12">
            <nav className="navbar navbar-inverse navbar-static-top">
              <div className="navbar-header">
                <button
                  aria-controls="navbar"
                  aria-expanded={isOpen}
                  data-target="#navbar"
                  data-toggle="collapse"
                  className={`navbar-toggle ${isOpen ? '' : 'collapsed'}`}
                  type="button"
                  onClick={toggleNav}
                >
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </button>
              </div>
              <div className={`navbar-collapse collapse ${isOpen ? 'in' : ''}`} id="navbar">
                <ul className="nav navbar-nav">
                  <li className={`dropdown ${openDropdown === 'products' ? 'open' : ''}`}>
                    <Link
                      to="/products"
                      className="dropdown-toggle first"
                      title="Products"
                      onClick={(e) => {
                        e.preventDefault();
                        handleDropdownToggle('products');
                      }}
                    >
                      products <span className="caret"></span>
                    </Link>
                    <ul className="dropdown-menu">
                      <li>
                        <Link to="/transport-management-system" title="Transport Management System">
                          Transport Management System
                        </Link>
                      </li>
                      <li>
                        <Link to="/payroll" title="Payroll">
                          Payroll
                        </Link>
                      </li>
                      <li>
                        <Link to="/gps-tracking-software" title="GPS Tracking as Software">
                          GPS Tracking as Software
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className={`dropdown ${openDropdown === 'services' ? 'open' : ''}`}>
                    <Link
                      to="/services"
                      className="dropdown-toggle"
                      title="Services"
                      onClick={(e) => {
                        e.preventDefault();
                        handleDropdownToggle('services');
                      }}
                    >
                      services <span className="caret"></span>
                    </Link>
                    <ul className="dropdown-menu">
                      <li>
                        <Link to="/applications" title="Applications">
                          Applications
                        </Link>
                      </li>
                      <li>
                        <Link to="/enterprise-resource-planning" title="ERP">
                          ERP
                        </Link>
                      </li>
                      <li>
                        <Link to="/consulting" title="Consulting">
                          Consulting
                        </Link>
                      </li>
                      <li>
                        <Link to="/mobility" title="Mobility">
                          Mobility
                        </Link>
                      </li>
                      <li>
                        <Link to="/business-process" title="Business Process">
                          Business Process
                        </Link>
                      </li>
                      <li>
                        <Link to="/gps-tracking-service" title="GPS Tracking as Service">
                          GPS Tracking as Service
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="/about" title="About Us">
                      about us
                    </Link>
                  </li>
                  <li>
                    <Link to="/careers" title="Careers">
                      Careers<span className="badge">2</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" title="Contact Us">
                      Contact us
                    </Link>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-12 col-xs-6 text-right rqst-demo-mob">
            <p className="rqstDemo">
              <Link to="/tms-pricing" title="TMS Pricing" className="btn btn-lg btn-primary">
                TMS Pricing
              </Link>
            </p>
            <div className="phone-no color1">
              <Link to="/contact" title="Request a Demo">
                Request a Demo
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

